import { CloudOff as CloudOffIcon } from '@mui/icons-material';
import { StatusPage, withJob } from 'cleveron-web-components';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import * as snackbarActions from '../../../actions/snackbar';

function Error408({ id, route }) {
    return (
        <StatusPage
            Icon={CloudOffIcon}
            buttonLink={route || '/'}
            buttonTextKey="actions.tryAgain"
            id={id}
            textBottomKey="error.timeoutText2"
            textTopKey="error.timeoutText"
            titleKey="error.timeout"
        />
    );
}

const mapDispatchToProps = dispatch => bindActionCreators(snackbarActions, dispatch);

export default compose(
    connect(null, mapDispatchToProps),
    withJob({
        LoadingComponent: Error408,
        work: ({ closeSnackbar }) => closeSnackbar(),
    })
)(Error408);
